import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/base.scss'
import '@/assets/styles/common.scss'
// 修改为 vue-i18n v8.x (Vue 2 兼容版本)
import VueI18n from 'vue-i18n'

// 引入翻译信息
import en from './locales/en.json'
import fr from './locales/fr.json'

// 正确使用 VueI18n 插件
Vue.use(VueI18n)

// 创建 i18n 实例 (Vue 2 语法)
const i18n = new VueI18n({
  locale: 'en', // 设置默认语言
  messages: {
    en,
    fr
  }
})

Vue.use(ElementUI)

// 设置页面标题
document.title = 'MYTUTOR'

// 禁用 Vue DevTools
Vue.config.devtools = true
// 全局对象暴露
Vue.config.productionTip = false
Vue.prototype.isCross = true
localStorage.setItem('isCross', 'true')

new Vue({
  router,
  store,
  i18n, // 注入 i18n 实例
  render: h => h(App)
}).$mount('#app')
